import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ variables, palette,breakpoints }) => ({
  faqContent:{
    '& .title-icon': {
      color: palette.jet?.supportBrand01,
      marginRight:variables?.spacingA,
      position:'relative',
      top:variables?.spacingA
    },
    '& .faqcontent-title': {
      marginBottom:variables?.spacingG
    },
    '& .jetAccordion': {
      [breakpoints.down('xs')]: {
        width:'100% !important'
      },

    },
    '& .faqcontent-questions-container':{
      width: '1150px',
      [breakpoints.down('md')]: {
        width:'100%'
      },
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'space-around',
      [breakpoints.down('sm')]: {
        width:'100%',
        display:'block',
        paddingLeft:variables?.spacingC,
        paddingRight:variables?.spacingC
      },
    },
    '& .JetAccordionCollection':{
      margin:'0 auto',
      width:'536px',
      [breakpoints.down('md')]: {
        width:'49vw',
      },
      float:'left',
      justifyContent:'space-between',
      '& .faq-item':{
      },
      [breakpoints.down('sm')]: {
        float:'unset',
        width:'100%'
      }
    }
  }
}));

export default useStyles;
